<template>
    <el-dialog title="修改员工信息" v-model="data.editVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="姓名">
                <el-input v-model="editInfo.name" />
            </el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="editInfo.username" />
            </el-form-item>
            <el-form-item label="电话号码">
                <el-input v-model="editInfo.phone" />
            </el-form-item>
            <el-form-item label="身份证号">
                <el-input v-model="editInfo.idNumber" />
            </el-form-item>
            <el-form-item label="更新时间">
                <el-input v-model="editInfo.updateTime" disabled />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="新增员工信息" v-model="data.createVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="姓名">
                <el-input v-model="editInfo.name" />
            </el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="editInfo.username" />
            </el-form-item>
            <el-form-item label="电话号码">
                <el-input v-model="editInfo.phone" />
            </el-form-item>
            <el-form-item label="身份证号">
                <el-input v-model="editInfo.idNumber" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="删除员工信息" v-model="data.deleteVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item>
                是否删除“{{ editInfo.name }}”相关的员工信息？
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">确认</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-button type="primary" @click="handleCreate">新增</el-button>
    <el-table :data="employee.employeeInfo" stripe border>
        <el-table-column show-overflow-tooltip prop="name" label="姓名" />
        <el-table-column show-overflow-tooltip prop="username" label="用户名" />
        <el-table-column show-overflow-tooltip prop="phone" label="电话号码" />
        <el-table-column show-overflow-tooltip prop="status" label="状态" />
        <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" />
        <!-- <el-table-column show-overflow-tooltip v-for="(item, key) in employee.colName" :key="key" :prop="item"
            :label="employee.colLabel[key]" /> -->
        <el-table-column label="操作" fixed="right" width="250">
            <template #default="scope">
                <el-button type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="default" @click="handleEnable(scope.$index, scope.row)">{{ scope.row.status ===
                    0 ? "启用" : "禁用" }}</el-button>
                <el-button type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination v-if="employee" layout="prev, pager, next" :current-page="data.currentPage" :size="data.pagesize"
        :total="employee.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
</template>
<script setup>
import { ref } from 'vue';
import { defineEmits } from 'vue';

import service from '@/utils/request.js'

const editInfo = ref({
    name: null,
    username: null,
    phone: null,
    idNumber: null,
    status: 1,
    updateTime: null
})
const originInfo = ref()
const emit = defineEmits(['refreshData']);

const props = defineProps({
    employee: {
        type: Object,
        default: {}
    },
    parentCurrentPage: {
        type: Number
    },
    charaNameList: {
        type: Object
    },
})

const data = ref({
    submit_button_disabled: false,
    loading: false,
    currentPage: 1,
    pagesize: 10,
    editVisible: ref(false),
    createVisible: ref(false),
    deleteVisible: ref(false)
});

const handleEdit = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    originInfo.value = JSON.parse(JSON.stringify(row));
    data.value.editVisible = true;
}

const handleDelete = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    data.value.deleteVisible = true;
}

const handleCreate = () => {
    data.value.createVisible = true;
    resetEditInfo();
}

const cancel = () => {
    data.value.editVisible = false;
    data.value.createVisible = false;
    data.value.deleteVisible = false;
}

const submit = async () => {
    if (data.value.editVisible) {
        if (JSON.stringify(editInfo.value) === JSON.stringify(originInfo.value)) {
            data.value.editVisible = false;
        }
        try {
            // 表格校验
            data.loading = true;
            const res = await service.put("/admin/employee", editInfo.value)
            if (res.data != false) {
                emit('refreshData', data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.editVisible = false;
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.createVisible) {
        try {
            // 表格校验
            data.loading = true;
            editInfo.value.updateTime = new Date();
            const res = await service.post("/admin/employee", editInfo.value)
            if (res.data != false) {
                emit('refreshData', data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.createVisible = false;
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.deleteVisible) {
        try {
            // 表格校验
            data.loading = true;
            const res = await service.delete("/admin/employee", {
                params: {
                    id: editInfo.value.id
                }
            })
            if (res.data != false) {
                emit('refreshData', data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.deleteVisible = false;
        } catch (error) {
            console.log(error);
        }
    }

}

const handleEnable = async (id, row) => {
    try {
        const status = row.status === 1 ? 0 : 1;
        const url = `/admin/employee/status/${status}`;
        const res = await service.post(url, null, {
            params: {
                id: row.id
            }
        });
        if (res.data != false) {
            emit('refreshData', data.value.currentPage, data.value.pagesize);
        } else {
            console.log(error);
        }
    } catch (error) {
        console.log(error);
    }
}

const handleCurrentChange = (val) => {
    data.value.currentPage = val;
    emit('refreshData', data.value.currentPage, data.value.pagesize);
}

const handleSizeChange = (val) => {
    return
}

const resetEditInfo = () => {
    editInfo.value = {
        name: null,
        username: null,
        phone: null,
        idNumber: null,
        status: 1,
        updateTime: null
    };
}
</script>
<style scoped></style>